import { getEnvVar } from '../envUtils.ts';
import ApiService from "./ApiService";
// import { BASE_APP_URL } from "./ApiService";

const getProjects = () => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}project`);
};

const getProjectbyId = (projectId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}project/${projectId}`);
};

const createMission = (payload) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission`, payload);
}

const updateMission = (missionId, payload) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}`, payload);
}
const updateMissionStations = (missionId, payload) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}missions/patch/${missionId}`, payload);
}

const get_mission_by_id = (missionId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}`);
}
const startMissionBuild = (mission, buildName, buildType) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}build?missionId=${mission}&buildLabel=${buildName}&buildType=${buildType}`);
}

const gettMissionBuild = () => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}build`);
}
const gettMissionId = (tenant_id) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission?tenantId=${tenant_id}`);
}
const deleteMission = (missionId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}`);
}

const getMissionPayload = (selectedTemplate, nameOfMission, isDraft, pageNumber) => {
  let payload = {
    "name": nameOfMission,
    "description": "",
    "mission-attributes": selectedTemplate['mission-attributes'],
    "sbpName": nameOfMission,
    "sbpDescription": "",
    "sbpBuildInfo": selectedTemplate.sbps[0].build_info,
    "sbpAssembly": selectedTemplate.sbps[0].versions[0].assembly
  }
  if (isDraft) {
    payload["mission-attributes"].status = "draft";
    payload["mission-attributes"].pageNumber = pageNumber;
  } else {
    payload["mission-attributes"].status = "configured";
  }

  return payload;
}

const getMissionSatInfo = (missionId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroupDetails`)
}

const deployBuild = (buildId, missionId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}build/mission?buildId=${buildId}&missionId=${missionId}`, {});
}

const getDeployStatus = (missionId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}build/mission?missionId=${missionId}`, {});
}

const startTest = (missionId, testCaseId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test-run?missionId=${missionId}&testCaseId=${testCaseId}`, {});
}


const getTestRuns = (missionId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test-run?missionId=${missionId}`);
}

const getTestCases = () => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test-case`);
}

const downloadTrueTwinPayloadConfig = (trueTwinId, fileId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/truetwin/${trueTwinId}/download?fileId=${fileId}`);
}
const downloadTrueTwinADCSConfig = (trueTwinId, fileName) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/truetwin/${trueTwinId}/downloadfile?filename=${fileName}`);
}

const create_new_satellites = (data, mission_id) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${mission_id}/satelliteGroup`, data);
}

const get_satellites_by_mission_id = (missionId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup`,);
}
const get_satellite_by_sat_id = (satId, mission_id) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${mission_id}/satelliteGroup/${satId}`,);
}

const get_payload_by_sat_id = (satId, missionId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup/${satId}/payload`,);
}

const get_payload_by_payload_id = (satId, payload_id, missionId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup/${satId}/payload/${payload_id}`,);
}

const update_payload_by_payload_id = (missionId, satId, payload_id, payload) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup/${satId}/payload/${payload_id}`, payload);
}

const get_edge_by_sat_id = (satId, missionId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup/${satId}/edge`,);
}


const update_satellites = (satId, data) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/satelliteGroup/${satId}/`, data);
}

const edit_satellite = (missionId, satId, data) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup/${satId}`, data);
}

const update_satellite_data = (missionId, satId, data) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup/${satId}`, data);
}

const delete_payload = (missionId, satelliteGroupId, payloadId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup/${satelliteGroupId}/payload/${payloadId}`)
}

const delete_edge = (missionId, satelliteGroupId, edgeId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup/${satelliteGroupId}/edge/${edgeId}`)
}

const add_sequence = (data, satId, missionId, payloadId) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup/${satId}/payload/${payloadId}/sequence`, data);
}

const update_sequence = (satId, missionId, payloadId, sequenceId, data) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup/${satId}/payload/${payloadId}/sequence/${sequenceId}`, data);
}

const delete_sequence = (satId, missionId, payloadId, sequenceId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup/${satId}/payload/${payloadId}/sequence/${sequenceId}`,);
}

const add_edge = (satId, missionId, data) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup/${satId}/edge`, data);
}

const add_payload = (satId, missionId, data) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup/${satId}/payload`, data);
}

const add_bus = (satId, missionId, templateId) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup/${satId}/bus?templateId=${templateId}`);
}

const clone_satellite_group = (missionId, groupId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup/${groupId}/clone`,);
}

const delete_satellite = (satId, missionId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup/${satId}`,);
}

const post_service_obeject = (satId, body) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}satellite/${satId}`, body);
}

const getTasks = (satId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${satId}/task`,);
};

const deleteTask = (task_id) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}task?taskId=${task_id}`,);
}
const postTaskPlan = (body) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}taskplan`, body);
}
const getTaskPlan_by_id = (taskPlanId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}taskplan?taskPlanId=${taskPlanId}`);
};
const getAllTaskPlan = (satId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${satId}/taskplan`);
};

const deleteTaskPlanById = (taskPlanId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}taskplan?taskPlanId=${taskPlanId}`,)
}

const updateTaskPLanById = (taskPlanId, data) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}taskplan?taskPlanId=${taskPlanId}`, data)
}
const postSchedule = (body) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}schedule`, body);
}

const putSchedule = (schedule_id, body) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}schedule?scheduleId=${schedule_id}`, body);
}

const getMissions = (satId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${satId}/schedule`,);
};

const getGroundLinkList = (satId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}satellite/${satId}/groundlink?=${satId}`,);
};

const createGroundLink = (satId, data) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}satellite/${satId}/groundlink?=${satId}`, data);
};

const deleteGroundLink = (satId, name) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}satellite/${satId}/groundlink?name=${name}`,);
};


const getGroundStations = (scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/groundstations?scenarioId=${scenarioId}`);
}


const cloneScenario = (id, name, useExisting) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/clone?scenarioId=${id}&scenarioName=${name}&useExisting=${useExisting}`,);
}

const postScenario = (body) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario`, body);
}

const uploadScenarioFile = (scenarioId, file) => {
  return ApiService.upload(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/fileUpload?scenarioId=${scenarioId}`, file);
}

const putScenario = (scenarioId, body) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario?scenarioId=${scenarioId}`, body);
}
const patchScenario = (scenarioId, body) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario?scenarioId=${scenarioId}`, body);
}
const addExperimentalObjects = (scenarioId, body) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/attachobits?scenarioId=${scenarioId}`, body);
}

const getScenarioById = (id) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario?scenarioId=${id}`);
}

const getAllScenarios = (satId, ttId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/all?satId=${satId}&truetwinId=${ttId}`)
}

const deleteScenario = (scenarioId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario?scenarioId=${scenarioId}`)
}
const runSimulation = (data) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/simulation`, data)
}

const getOribtData = (scenarioId, trueTwinId, propagation) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/orbit?scenarioId=${scenarioId}&trueTwinId=${trueTwinId}&propagation=${propagation}`);
}

const getSimulationStatus = (simulationId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/simulation/status?simulationId=${simulationId}`);
}

const generateSchedule = (scenarioId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/generateschedule?scenarioId=${scenarioId}`);
}

const downloadSchedule = (scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/exportschedule?scenarioId=${scenarioId}`);
}

const createValidationTest = (data) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}validation-test`, data)
}
const updateValidationTest = (validationId, data) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}validation-test?validationTestId=${validationId}`, data)
}
const deleteValidationTest = (validationId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}validation-test?validationTestId=${validationId}`)
}

const getAllValidationTests = (satId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}validation-test/all?satId=${satId}`)
}

const getValidationTest = (validationTestId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}validation-test?validationTestId=${validationTestId}`)
}

const runValidationTest = (body, validationTestId, flatSatId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}validation-test/run?validationTestId=${validationTestId}&flatSatId=${flatSatId}`, body)
}

const getAllValidationRunsTest = (satId, flatSatId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}validation-test/run?satId=${satId}&flatSatId=${flatSatId}`)
}

const getStatusOfValidationRunsTest = (validationRunTestId, senarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}validation-test/runStatus?validationRunTestId=${validationRunTestId}&scenarioId=${senarioId}`)
}

const deleteValidationRunTest = (validationRunTestId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}validation-test/run?validationRunTestId=${validationRunTestId}`)
}

const stopValidationRunTest = (validationRunTestId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}validation-test/stop?validationRunTestId=${validationRunTestId}`)
}

const getTestPlanbyId = (testPlanId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}validation-test?validationTestId=${testPlanId}`);
}
const uploadFile = (ttId, satId, name, comment, category, taskPlanId, file) => {
  return ApiService.upload(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/uploadLogFile?truetwinId=${ttId}&satId=${satId}&comment=${comment}&category=${category}&name=${name}&taskPlanId=${taskPlanId}`, file);
}
const getTaskFromTaskType = (taskType) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}task/getTaskByType?taskType=${taskType}`);
}
const getAllTask = (satId, mission_id) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}task/${satId}/all`);
}

const createGsProvider = (missionId, data) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/gsConfig`, data)
}

const putSatelliteConfig = (satId) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}satellite/defaultConfig?satId=${satId}`)
}

const postSatelliteConfig = (body, satId) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}satellite/configuration/${satId}`, body)
}

const getCommsCount = (ttId, scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/telemetry/counts?truetwinId=${ttId}&scenarioId=${scenarioId}`);
}

const getControlMode = (scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/ADCSControlModeLogs?scenarioId=${scenarioId}`);
}

const getEstimationMode = (scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/ADCSControlEstModeLogs?scenarioId=${scenarioId}`);
}

const postScenarioSchedule = (scenarioId, body) => {
  return ApiService.upload(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/importschedulefile?scenarioId=${scenarioId}`, body)
}

const postSimulationGraph = (type, scenarioId, data) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/graphs/${type}?scenarioid=${scenarioId}`, data)
}

const deleteAdditionalObject = (scenarioId, orbitId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/attachobits?scenarioId=${scenarioId}&orbitId=${orbitId}`)
}

const getPredictionStatus = (scenarioId) => {
  return ApiService.prediction(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/prediction?scenarioId=${scenarioId}`)
}

const postThreedModel = (satID, mission_id, body) => {
  return ApiService.upload(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}satellite/${satID}/model?missionId=${mission_id}`, body)
}

const getModelUrl = (satId, modelName) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}satellite/model/${satId}/${modelName}`)
}

const postFeature = (mission_id, data) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${mission_id}/areaOfInterests`, data)
}

const getAoiManagersByMissionId = (mission_id) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${mission_id}/areaOfInterestManager`);
}

const getAllAoisByManagerId = (areaOfInterestManagerId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/areaOfInterests/${areaOfInterestManagerId}`);
}

const deleteAoiManagerByManagerId = (areaOfInterestManagerId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/areaOfInterestManager/${areaOfInterestManagerId}`)
}

const deleteAoiById = (AoiId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/areaOfInterest/${AoiId}`)
}

const updateAoiById = (aoiId, data) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/areaOfInterest/${aoiId}`, data)
}

const getAoiById = (aoiId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/areaOfInterest/${aoiId}`);
}

const getAllAoisByType = (mission_id, type) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${mission_id}/areaOfInterests/${type}`);
}
const getAllAoisByMissionId = (mission_id) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${mission_id}/areaOfInterests`);
}

const getAdhocComponents = (missionId) => {
  const query = missionId ? `?missionId=${encodeURIComponent(missionId)}` : '';
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}task/gettaskbycomponentname${query}`)
}

const getTaskById = (taskId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}task?taskId=${taskId}`)
}

const deleteTaskByOperationId = (taskId, operationId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}task/${taskId}/operation?operationId=${operationId}`)
}

const getTaskByoperationId = (taskId, operationId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}task/deleteSequenceByOperationId?taskId=${taskId}&operationId=${operationId}`)
}

const putTasks = (task_id, body) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}task?taskId=${task_id}`, body);
}

const postTask = (body) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}task`, body);
}

//------Test Plan APIs----------//
const importTestPlans = (missionId, satelliteGroupId, satelliteId, body) => {
  return ApiService.upload(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}/v1/mission/${missionId}/validate/testPlans/import?satelliteGroupId=${satelliteGroupId}&satelliteId=${satelliteId}`, body);
}

const exportTestPlans = (missionId, satelliteId, body) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}/v1/mission/${missionId}/validate/testPlans/export?satelliteId=${satelliteId}`, body);
}

const deleteTestPlans = (missionId, body) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}/v1/mission/${missionId}/validate/testPlans`, body);
}

const getTestPlanConfig = (missionId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}/v1/mission/${missionId}/validate/testPlansConfig`);
}

const createTestPlan = (missionId, satelliteGroupId, satelliteId, body) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/testPlans?satelliteGroupId=${satelliteGroupId}&satelliteId=${satelliteId}`, body);
}

const updateTestPlan = (missionId, testPlanId, satelliteGroupId, satelliteId, body) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/testPlans/${testPlanId}?satelliteGroupId=${satelliteGroupId}&satelliteId=${satelliteId}`, body);
}

const getTestPlans = (missionId, satelliteId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/testPlans?satelliteId=${satelliteId}`);
}

const getTestPlanById = (missionId, testPlanId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/testPlans/${encodeURIComponent(testPlanId)}`);
}

//----------------------------------//
const deleteSatelliteBucket = (satId, mission_id) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}satellite/${satId}/model?missionId=${mission_id}`)
}

const getMissionModellingModels = (mission_id) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/model/all?missionid=${mission_id}`)
}

const createMissionModellingModal = (mission_id, body) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/model?missionid=${mission_id}`, body)
}

const getMissionModelById = (missionId, scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/model?missionid=${missionId}&scenarioid=${scenarioId}`)
}

const updateMissionModel = (missionId, scenarioId, body) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/model?missionid=${missionId}&scenarioid=${scenarioId}`, body)
}

const deleteMissionModel = (missionId, scenarioId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/model?missionid=${missionId}&scenarioid=${scenarioId}`)
}

const createSatelliteGroup = (missionId, scenarioId, body) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group?missionid=${missionId}&scenarioid=${scenarioId}`, body)
}

const editSatelliteGroup = (missionId, scenarioId, groupId, body) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group/${groupId}/edit?missionid=${missionId}&scenarioid=${scenarioId}`, body)
}

const getSatelliteGroups = (missionId, scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group/all?missionid=${missionId}&scenarioid=${scenarioId}`)
}

const buildOrbitReadQuery = (missionId, scenarioId, options = {}) => {
  const params = new URLSearchParams({
    missionid: missionId,
    scenarioid: scenarioId,
  });
  if (options.from_utc != null) params.set('from_utc', String(options.from_utc));
  if (options.to_utc != null) params.set('to_utc', String(options.to_utc));
  if (options.stepSizeSeconds != null) params.set('stepSizeSeconds', String(options.stepSizeSeconds));
  if (options.max_points != null) params.set('max_points', String(options.max_points));
  if (options.page_token != null) params.set('page_token', String(options.page_token));
  return params.toString();
}

const getSatelliteGroupStatusOverview = (missionId, scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group/all/status-overview?missionid=${missionId}&scenarioid=${scenarioId}`)
}

const getSatelliteGroupOrbit = (missionId, scenarioId, groupId, options = {}) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group/${groupId}/orbit?${buildOrbitReadQuery(missionId, scenarioId, options)}`)
}

const getAllSatelliteGroupOrbit = (missionId, scenarioId, options = {}) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group/all/orbit?${buildOrbitReadQuery(missionId, scenarioId, options)}`)
}

const getOrbitTrack = (missionId, scenarioId, satelliteId, options = {}) => {
  const params = new URLSearchParams(buildOrbitReadQuery(missionId, scenarioId, options));
  params.set('satellite_id', satelliteId);
  if (options.track_type != null) params.set('track_type', String(options.track_type));
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenario/${scenarioId}/orbit-track?${params.toString()}`)
}

const runAccessWindows = (missionId, scenarioId, body = {}) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenario/${scenarioId}/access-windows/run`, body)
}

const runAccessAnalysis = (missionId, scenarioId, body = {}) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenario/${scenarioId}/access-analysis/run`, body)
}

const getAccessAnalysisReports = (missionId, scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenario/${scenarioId}/access-analysis/reports`)
}

const getAccessAnalysisReportById = (missionId, scenarioId, reportId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenario/${scenarioId}/access-analysis/reports/${encodeURIComponent(reportId)}`)
}

const getAccessAnalysisReportSummary = (missionId, scenarioId, reportId, filters = undefined) => {
  let url = `${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenario/${scenarioId}/access-analysis/reports/${encodeURIComponent(reportId)}/summary`;
  if (filters && filters.length > 0) {
    const params = new URLSearchParams({
      filters: JSON.stringify(filters)
    });
    url += `?${params.toString()}`;
  }
  return ApiService.get(url);
}

const getAccessAnalysisReportEvents = (missionId, scenarioId, reportId, options = {}) => {
  const params = new URLSearchParams({
    page: String(options.page ?? 0),
    size: String(options.size ?? 50),
    sortBy: String(options.sortBy ?? 'aosUtc'),
    sortDir: String(options.sortDir ?? 'asc'),
  });
  if (options.filters && options.filters.length > 0) {
    params.set('filters', JSON.stringify(options.filters));
  }
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenario/${scenarioId}/access-analysis/reports/${encodeURIComponent(reportId)}/events?${params.toString()}`)
}

const getAccessAnalysisReportPlots = (missionId, scenarioId, reportId, plotParams, plotType = 'aer') => {
  const params = new URLSearchParams();
  if (typeof plotParams === 'string') {
    params.set('pairkey', plotParams);
  } else {
    if (plotParams?.pairKey != null) {
      params.set('pairkey', String(plotParams.pairKey));
    } else if (plotParams?.satelliteId != null && plotParams?.groundStationId != null) {
      params.set('pairkey', `sat:${plotParams.satelliteId}|ground_station:${plotParams.groundStationId}`);
    }
  }
  params.set('plottype', plotParams?.plotType ?? plotType);
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenario/${scenarioId}/access-analysis/reports/${encodeURIComponent(reportId)}/plots?${params.toString()}`)
}

const chatAccessAnalysisReport = (missionId, scenarioId, body = {}) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenario/${scenarioId}/access-analysis/chat`, body)
}

const deleteAccessAnalysisReport = (missionId, scenarioId, reportId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenario/${scenarioId}/access-analysis/reports/${encodeURIComponent(reportId)}`)
}

const runCoverageAnalysis = (missionId, scenarioId, body = {}) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenarios/${scenarioId}/coverage-analysis`, body)
}

const getCoverageAnalysisReports = (missionId, scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenarios/${scenarioId}/coverage-analysis`)
}

const getCoverageAnalysisReportById = (missionId, scenarioId, reportId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenarios/${scenarioId}/coverage-analysis/${encodeURIComponent(reportId)}`)
}

const deleteCoverageAnalysisReport = (missionId, scenarioId, reportId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenarios/${scenarioId}/coverage-analysis/${encodeURIComponent(reportId)}`)
}

const renameCoverageAnalysisReport = (missionId, scenarioId, reportId, name) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenarios/${scenarioId}/coverage-analysis/${encodeURIComponent(reportId)}`, { reportName: name })
}

const getCoverageSimpleCoverage = (missionId, scenarioId, reportId, aoiId, options = {}) => {
  const params = new URLSearchParams({
    satelliteIds: options.satelliteIds ?? '',
    includePasses: 'true',
    page: String(options.page ?? 0),
    size: String(options.size ?? 50)
  });
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenarios/${scenarioId}/coverage-analysis/${encodeURIComponent(reportId)}/aois/${encodeURIComponent(aoiId)}/simple-coverage?${params.toString()}`)
}

const getCoverageGapSummary = (missionId, scenarioId, reportId, aoiId, options = {}) => {
  const params = new URLSearchParams({
    satelliteIds: options.satelliteIds ?? '',
    includeSpots: 'true',
    page: String(options.page ?? 0),
    size: String(options.size ?? 50)
  });
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenarios/${scenarioId}/coverage-analysis/${encodeURIComponent(reportId)}/aois/${encodeURIComponent(aoiId)}/gap-summary?${params.toString()}`)
}

const getCoverageRevisitSummary = (missionId, scenarioId, reportId, aoiId, options = {}) => {
  const params = new URLSearchParams({
    satelliteIds: options.satelliteIds ?? '',
    includeSpots: 'true',
    page: String(options.page ?? 0),
    size: String(options.size ?? 50)
  });
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenarios/${scenarioId}/coverage-analysis/${encodeURIComponent(reportId)}/aois/${encodeURIComponent(aoiId)}/revisit-summary?${params.toString()}`)
}

const getCoverageAnalysisPasses = (missionId, scenarioId, reportId, aoiId, options = {}) => {
  const params = new URLSearchParams({
    satelliteIds: options.satelliteIds ?? '',
    page: String(options.page ?? 0),
    size: String(options.size ?? 1000)
  });
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenarios/${scenarioId}/coverage-analysis/${encodeURIComponent(reportId)}/aois/${encodeURIComponent(aoiId)}/passes?${params.toString()}`)
}

const getCoverageAnalysisSpots = (missionId, scenarioId, reportId, aoiId, options = {}) => {
  const params = new URLSearchParams({
    satelliteIds: options.satelliteIds ?? '',
    page: String(options.page ?? 0),
    size: String(options.size ?? 1000)
  });
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenarios/${scenarioId}/coverage-analysis/${encodeURIComponent(reportId)}/aois/${encodeURIComponent(aoiId)}/spots?${params.toString()}`)
}


const getAccessWindowStatusOverview = (missionId, scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenario/${scenarioId}/access-windows/status-overview`)
}

const getAccessWindowRun = (missionId, scenarioId, runId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenario/${scenarioId}/access-windows/run/${runId}`)
}

const buildAccessWindowQuery = (options = {}) => {
  const params = new URLSearchParams();
  if (options.satelliteId != null) params.set('satelliteId', String(options.satelliteId));
  if (options.counterpartyId != null) params.set('counterpartyId', String(options.counterpartyId));
  if (options.counterpartyKind != null) params.set('counterpartyKind', String(options.counterpartyKind));
  if (options.fromUtc != null) params.set('fromUtc', String(options.fromUtc));
  if (options.toUtc != null) params.set('toUtc', String(options.toUtc));
  if (options.pageSize != null) params.set('pageSize', String(options.pageSize));
  if (options.pageToken != null) params.set('pageToken', String(options.pageToken));
  const query = params.toString();
  return query ? `?${query}` : '';
}

const getAccessWindows = (missionId, scenarioId, options = {}) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenario/${scenarioId}/access-windows${buildAccessWindowQuery(options)}`)
}

const getAccessWindowPairTimeline = (missionId, scenarioId, pairKey) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenario/${scenarioId}/access-windows/pairs/${encodeURIComponent(pairKey)}/timeline`)
}

const cloneMissionSimulationGroup = (missionId, scenarioId, groupId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group/${groupId}/clone?missionid=${missionId}&scenarioid=${scenarioId}`)
}

const deleteMissionSimulationGroup = (missionId, scenarioId, groupId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group?missionid=${missionId}&scenarioid=${scenarioId}&groupid=${groupId}`)
}

const deleteMissionSimulationGroups = (missionId, scenarioId, groupIds) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group/all?missionid=${missionId}&scenarioid=${scenarioId}`, { groupIds })
}

const updateSingleSatelliteConfig = (missionId, scenarioId, groupId, satId, body) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group/${groupId}/singleSatelliteConfig?missionid=${missionId}&scenarioid=${scenarioId}&satid=${satId}`, body)
}

const updateGroupSatellitesConfig = (missionId, scenarioId, groupId, body) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group/${groupId}/satellites/config?missionid=${missionId}&scenarioid=${scenarioId}`, body)
}

const addSatelliteSensor = (missionId, scenarioId, groupId, satId, body) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group/${groupId}/satellite/${satId}/sensors?missionid=${missionId}&scenarioid=${scenarioId}`, body)
}

const addSatelliteSensorsBulk = (missionId, scenarioId, groupId, satId, body) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group/${groupId}/satellite/${satId}/sensors/bulk?missionid=${missionId}&scenarioid=${scenarioId}`, body)
}

const updateSatelliteSensor = (missionId, scenarioId, groupId, satId, sensorId, body) => {
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group/${groupId}/satellite/${satId}/sensors/${sensorId}?missionid=${missionId}&scenarioid=${scenarioId}`, body)
}

const deleteSatelliteSensor = (missionId, scenarioId, groupId, satId, sensorId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/group/${groupId}/satellite/${satId}/sensors/${sensorId}?missionid=${missionId}&scenarioid=${scenarioId}`)
}

//// Launch Apis ////

const postOrbitDetails = (body) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}project/tle`, body);
}
const updateOrbitDetails = (satId, tleType, body) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}project/tle?satId=${satId}&tleType=${tleType}`, body);
}
const getLatestOrbitDetails = (satId, launchType) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}project/tle?satId=${satId}&tleType=${launchType}`);
}

const get_all_orbit_details = (mission_id, satelliteGroupId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${mission_id}/satelliteGroup/${satelliteGroupId}/satellites/orbitParameters`);
}
const getAllOrbitDetails = (satId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}project/tle/all?satId=${satId}`);
}
const deleteOrbitDetails = (satId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}project/tle?satId=${satId}`);
}

// This API is used with promote to collect button for Mission Orchestrator
const post_ucp_data = (missionId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}oms/schedules/${missionId}/init`);
}


const getAllSatellitesByGroupId = (missionId, satelliteGroupId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup/${satelliteGroupId}/satellites`);
}

//// Launch Apis ////


//// Sensor Placement API's ////
const getAllSensors = (satId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}project/satelliteDesigner/sensorConfig/${satId}`);
}

const postControlMode = (body, satId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}project/satelliteDesigner/controlMode/${satId}`, body);
}

const updateControlMode = (body, satId, name) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}project/satelliteDesigner/controlMode/${satId}?name=${name}`, body);
}

const getControlModes = (satId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}project/satelliteDesigner/controlMode/${satId}`);
}

const sensorAnalysis = (body, satId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}project/satelliteDesigner/sensorPlacementAnalysis/${satId}`, body);
}

const getAllReports = (satId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}project/satelliteDesigner/sensorPlacementAnalysis/${satId}`);
}

const deleteReoprt = (name, satId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}project/satelliteDesigner/sensorPlacementAnalysis/${satId}?name=${name}&mode=1`);
}

const getMoi = (satId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}project/satelliteDesigner/satelliteGroupConfiguration/${satId}`);
}

const deleteControlMode = (sat_id, name) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}project/satelliteDesigner/controlMode/${sat_id}?name=${name}&mode=1`);
}

const hwilScenarioDeployment = (missionId, body) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/truetwin/deployment`, body)
}


/// Thermal Analysis API's ////

const getThermalConfig = (missionId, satelliteGroupId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}satellite/${satelliteGroupId}/thermalConfig?missionId=${missionId}`);
}

const putThermalConfig = (missionId, satelliteGroupId, body) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}satellite/${satelliteGroupId}/thermalConfig?missionId=${missionId}`, body);
}

// fault injectoion operations
const postFaultInjectionPlan = (missionId, satelliteGroupId, body) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/satellitegroup/${satelliteGroupId}/faultplan`, body)
}

const editFaultInjectionPlan = (missionId, satelliteGroupId, faultPlanId, body) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/satellitegroup/${satelliteGroupId}/faultplan/${faultPlanId}`, body)
}

const getAllFaultPlansBySatId = (missionId, satelliteGroupId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/satellitegroup/${satelliteGroupId}/faultplans`,)
}

const getFaultDetails = (missionId, satelliteGroupId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/satellitegroup/${satelliteGroupId}/faultdetails`,)
}

const deleteFaultInjectionPlan = (missionId, satelliteGroupId, faultPlanId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/satellitegroup/${satelliteGroupId}/faultplan/${faultPlanId}`,)
}
const getFaultListByFaultPlanId = (missionId, satelliteGroupId, faultPlanId) => {
  return ApiService.get(
    `${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/satellitegroup/${satelliteGroupId}/faultplan/${faultPlanId}`
  )
}
//scenario fault plan api's
const postFaultScheduleData = (missionId, scenarioId, body) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/simulate/${missionId}/scenario/${scenarioId}/simulationfaults:generate`, body);
}

const getAllFaultScheduleData = (missionId, scenarioId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/simulate/${missionId}/scenario/${scenarioId}/faults:get`);
}

const patchFaultScheduleData = (missionId, scenarioId, faultScheduleId, body) => {
  return ApiService.patch(
    `${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/simulate/${missionId}/scenario/${scenarioId}/faultschedule/${faultScheduleId}/addfault`, body
  );
}

const deleteFaultsfromschedule = (missionId, scenarioId, faultScheduleId, faultId) => {
  return ApiService.delete(
    `${getEnvVar('REACT_APP_BACKEND_BASE_URL')}/v1/simulate/${missionId}/scenario/${scenarioId}/faultschedule/${faultScheduleId}/fault/${faultId}`
  );
};

const getTelemetriesByMissionAndSat = (missionId, satelliteId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}/groundstation/comms/tmCatalog`);
};

const getValidationConfigs = (missionId, satelliteGroupId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/satellitegroup/${satelliteGroupId}/tms-with-defaults`);
};

const getValidateTestCases = (missionId, satelliteId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/testCases?satelliteId=${satelliteId}`);
};

const postValidateTestCase = (missionId, satelliteGroupId, satelliteId, payload) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/testCase?satelliteGroupId=${satelliteGroupId}&satelliteId=${satelliteId}`, payload);
};

const getValidateTestCaseById = (missionId, testCaseId, satelliteId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/testCase/${testCaseId}?satelliteId=${satelliteId}`);
};

const putValidateTestCase = (missionId, testCaseId, satelliteGroupId, satelliteId, payload) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/testCase/${testCaseId}?satelliteGroupId=${satelliteGroupId}&satelliteId=${satelliteId}`, payload);
};

const deleteValidateTestCases = (missionId, satelliteId, testCaseIds) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/testCases?satelliteId=${satelliteId}`, { testCaseIds });
};

const exportValidateTestCases = (missionId, satelliteId, testCaseIds) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/testCases/export?satelliteId=${satelliteId}`, { testCaseIds });
};

const importValidateTestCases = (missionId, satelliteGroupId, satelliteId, formData) => {
  return ApiService.upload(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/testCases/import?satelliteGroupId=${satelliteGroupId}&satelliteId=${satelliteId}`, formData);
};

const getConflictDiff = (missionId, importType, fileId, conflictId) => {
  const type = importType === 'Test Cases' || importType === 'Test Case' ? 'testCases' : 'testPlans';
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/${type}/import/conflict/${conflictId}/diff?fileId=${fileId}`);
};

const commitImport = (missionId, importType, payload) => {
  const type = importType === 'Test Cases' || importType === 'Test Case' ? 'testCases' : 'testPlans';
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/${type}/import/commit`, payload);
};

// ─── Import Conflict Resolution API Specification Endpoints (#1–#20) ───

const analyzeImport = (missionId, type, satelliteGroupId, satelliteId, formData) => {
  const typePath = type === 'Test Cases' || type === 'Test Case' ? 'testCases' : 'testPlans';
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/${typePath}/import/analyze?satelliteGroupId=${satelliteGroupId}&satelliteId=${satelliteId}`, formData);
};

const getImportSessionStatus = (missionId, importSessionId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/import/${importSessionId}`);
};

const getImportItemsList = (missionId, importSessionId, entityType, status = 'ALL') => {
  const typePath = entityType === 'TEST_CASE' || entityType === 'Test Cases' || entityType === 'Test Case' ? 'testCases' : 'testPlans';
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/import/${importSessionId}/${typePath}?status=${status}`);
};

const getConflictDiffV2 = (missionId, importSessionId, entityType, conflictId) => {
  const typePath = entityType === 'TEST_CASE' || entityType === 'Test Cases' || entityType === 'Test Case' ? 'testCases' : 'testPlans';
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/import/${importSessionId}/conflicts/${typePath}/${conflictId}/diff`);
};

const resolveConflict = (missionId, importSessionId, entityType, conflictId, payload) => {
  const typePath = entityType === 'TEST_CASE' || entityType === 'Test Cases' || entityType === 'Test Case' ? 'testCases' : 'testPlans';
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/import/${importSessionId}/conflicts/${typePath}/${conflictId}/resolve`, payload);
};

const skipAllConflicts = (missionId, importSessionId, entityType) => {
  const typePath = entityType === 'TEST_CASE' || entityType === 'Test Cases' || entityType === 'Test Case' ? 'testCases' : 'testPlans';
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/import/${importSessionId}/conflicts/${typePath}/skipAll`);
};

const getImportSummary = (missionId, importSessionId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/import/${importSessionId}/summary`);
};

const getImportTestPlanDrilldown = (missionId, importSessionId, testPlanName) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/import/${importSessionId}/testPlans/${encodeURIComponent(testPlanName)}`);
};

const commitImportSession = (missionId, importSessionId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/import/${importSessionId}/commit`);
};

const cancelImportSession = (missionId, importSessionId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/import/${importSessionId}`);
};

const checkImportNameAvailability = (missionId, importSessionId, entityType, name) => {
  const typeStr = entityType === 'TEST_CASE' || entityType === 'Test Cases' || entityType === 'Test Case' ? 'TEST_CASE' : 'TEST_PLAN';
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/import/${importSessionId}/checkName?entityType=${typeStr}&name=${encodeURIComponent(name)}`);
};

const refreshImportSession = (missionId, importSessionId) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/validate/import/${importSessionId}/refresh`);
};

const resetTestCasesToDefaults = (missionId, satelliteGroupId, payload) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/satellitegroup/${satelliteGroupId}/reset-test-cases-to-defaults`, payload);
};

const validateFaultPlan = (missionId, satelliteGroupId, body) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/mission/${missionId}/satellitegroup/${satelliteGroupId}/validate/faultplan`, body);
};

////////-------------/////////////
const get_eligile_sat_for_promote = (missionId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/promoteCandidateSatelliteGroups`,);
}


//// Simulator APIs ////

// Getting the List of uploaded simulators
const getSimulatorList = (missionId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/simulators/${missionId}`,);
}

const deleteSimulator = (missionId, simulatorId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/simulators/${missionId}/${simulatorId}`,);
}

// Upload the simulator file
const uploadSimulator = (missionId, formData) => {
  return ApiService.upload(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/simulators/${missionId}/upload`, formData);
};

//// XTCE Registry APIs ////

// List all XTCE registry entries for a mission (system + custom)
const getXtceList = (missionId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/xtce/${missionId}`,);
}

// Get the currently active (in-use) XTCE for a mission
const getActiveXtce = (missionId) => {
  return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/xtce/${missionId}/active`,);
}

// Upload a custom XTCE XML (formData: xtceName, xtceVersion, xtceFile)
const uploadXtce = (missionId, formData) => {
  return ApiService.upload(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/xtce/${missionId}/upload`, formData);
};

// Make an uploaded XTCE the active one for its mission
const activateXtce = (missionId, xtceId) => {
  return ApiService.put(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/xtce/${missionId}/${xtceId}/activate`, {});
};

// Delete a custom XTCE registry entry
const deleteXtce = (missionId, xtceId) => {
  return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/xtce/${missionId}/${xtceId}`,);
};

const patchComponentLatency = (missionId, satelliteGroupId, data) => { // Patches component boot-up and shutdown latency configs for a satellite group
  return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup/${satelliteGroupId}/componentlatency`, data);
};

const chatConstellationDesign = (missionId, scenarioId, payload) => {
  return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission-simulation/${missionId}/scenario/${scenarioId}/constellation-design/chat`, payload);
};

const MissionService = {
  chatConstellationDesign,
  getProjects,
  get_mission_by_id,
  getProjectbyId,
  createMission,
  updateMission,
  updateMissionStations,
  startMissionBuild,
  gettMissionBuild,
  gettMissionId,
  deleteMission,
  getMissionPayload,
  getMissionSatInfo,
  deployBuild,
  getDeployStatus,
  startTest,
  getTestRuns,
  getTestCases,
  downloadTrueTwinPayloadConfig,
  downloadTrueTwinADCSConfig,
  create_new_satellites,
  get_satellites_by_mission_id,
  update_satellites,
  edit_satellite,
  update_satellite_data,
  delete_payload,
  delete_edge,
  add_sequence,
  add_payload,
  add_bus,
  add_edge,
  clone_satellite_group,
  delete_satellite,
  getAllSatellitesByGroupId,
  get_satellite_by_sat_id,
  get_payload_by_sat_id,
  get_payload_by_payload_id,
  update_payload_by_payload_id,
  get_edge_by_sat_id,
  post_service_obeject,
  getTasks,
  deleteTask,
  postSchedule,
  getMissions,
  putSchedule,
  delete_sequence,
  update_sequence,
  postTaskPlan,
  getTaskPlan_by_id,
  getAllTaskPlan,
  deleteTaskPlanById,
  updateTaskPLanById,
  getGroundLinkList,
  createGroundLink,
  deleteGroundLink,
  getGroundStations,
  cloneScenario,
  postScenario,
  getScenarioById,
  putScenario,
  uploadScenarioFile,
  patchScenario,
  addExperimentalObjects,
  getAllScenarios,
  generateSchedule,
  downloadSchedule,
  deleteScenario,
  runSimulation,
  getOribtData,
  getSimulationStatus,
  createValidationTest,
  updateValidationTest,
  deleteValidationTest,
  getAllValidationTests,
  getValidationTest,
  runValidationTest,
  getAllValidationRunsTest,
  getStatusOfValidationRunsTest,
  deleteValidationRunTest,
  stopValidationRunTest,
  getTestPlanbyId,
  uploadFile,
  getTaskFromTaskType,
  getAllTask,
  postSatelliteConfig,
  getCommsCount,
  getControlMode,
  getEstimationMode,
  putSatelliteConfig,
  postScenarioSchedule,
  postSimulationGraph,
  deleteAdditionalObject,
  getPredictionStatus,
  postThreedModel,
  getModelUrl,
  // feature api
  postFeature,
  getAoiManagersByMissionId,
  getAllAoisByManagerId,
  deleteAoiManagerByManagerId,
  deleteAoiById,
  updateAoiById,
  getAoiById,
  getAllAoisByType,
  getAllAoisByMissionId,
  // NewTaskcreationApi //
  putTasks,
  postTask,
  getAdhocComponents,
  getTaskById,
  getTaskByoperationId,
  deleteTaskByOperationId,

  //Test Plan Apis//
  importTestPlans,
  exportTestPlans,
  deleteTestPlans,
  getTestPlanConfig,
  createTestPlan,
  updateTestPlan,
  getTestPlans,
  getTestPlanById,
  // NewTaskcreationApi //
  deleteSatelliteBucket,
  getMissionModellingModels,
  createMissionModellingModal,
  getMissionModelById,
  updateMissionModel,
  deleteMissionModel,
  createSatelliteGroup,
  editSatelliteGroup,
  getSatelliteGroups,
  getSatelliteGroupStatusOverview,
  getSatelliteGroupOrbit,
  getAllSatelliteGroupOrbit,
  getOrbitTrack,
  runAccessWindows,
  runAccessAnalysis,
  getAccessAnalysisReports,
  getAccessAnalysisReportById,
  getAccessAnalysisReportSummary,
  getAccessAnalysisReportEvents,
  getAccessAnalysisReportPlots,
  chatAccessAnalysisReport,
  deleteAccessAnalysisReport,
  runCoverageAnalysis,
  getCoverageAnalysisReports,
  getCoverageAnalysisReportById,
  deleteCoverageAnalysisReport,
  renameCoverageAnalysisReport,
  getCoverageSimpleCoverage,
  getCoverageGapSummary,
  getCoverageRevisitSummary,
  getCoverageAnalysisPasses,
  getCoverageAnalysisSpots,
  getAccessWindowStatusOverview,
  getAccessWindowRun,
  getAccessWindows,
  getAccessWindowPairTimeline,
  cloneMissionSimulationGroup,
  deleteMissionSimulationGroup,
  deleteMissionSimulationGroups,
  updateSingleSatelliteConfig,
  updateGroupSatellitesConfig,
  addSatelliteSensor,
  addSatelliteSensorsBulk,
  updateSatelliteSensor,
  deleteSatelliteSensor,

  //// Launch Apis ////
  postOrbitDetails,
  updateOrbitDetails,
  getLatestOrbitDetails,
  get_all_orbit_details,
  getAllOrbitDetails,
  deleteOrbitDetails,
  //// Launch Apis ////
  post_ucp_data,
  // Sensor placement API's
  getAllSensors,
  postControlMode,
  updateControlMode,
  getControlModes,
  sensorAnalysis,
  getAllReports,
  deleteReoprt,
  getMoi,
  deleteControlMode,
  hwilScenarioDeployment,

  postFaultInjectionPlan,
  getAllFaultPlansBySatId,
  getFaultDetails,
  getFaultListByFaultPlanId,
  editFaultInjectionPlan,
  deleteFaultInjectionPlan,

  postFaultScheduleData,
  patchFaultScheduleData,
  getAllFaultScheduleData,
  deleteFaultsfromschedule,
  validateFaultPlan,
  get_eligile_sat_for_promote,

  // Thermal Analysis API's
  getThermalConfig,
  putThermalConfig,

  // Simulators Apis
  getSimulatorList,
  deleteSimulator,
  uploadSimulator,

  // Test Case Apis
  getTelemetriesByMissionAndSat,
  getValidationConfigs,
  getValidateTestCases,
  postValidateTestCase,
  getValidateTestCaseById,
  putValidateTestCase,
  deleteValidateTestCases,
  exportValidateTestCases,
  importValidateTestCases,
  getConflictDiff,
  commitImport,
  // New V2 Import API Spec functions
  analyzeImport,
  getImportSessionStatus,
  getImportItemsList,
  getConflictDiffV2,
  resolveConflict,
  skipAllConflicts,
  getImportSummary,
  getImportTestPlanDrilldown,
  commitImportSession,
  cancelImportSession,
  checkImportNameAvailability,
  refreshImportSession,
  patchComponentLatency, // Export latency patch handler
  resetTestCasesToDefaults,
  // XTCE Registry APIs
  getXtceList,
  getActiveXtce,
  uploadXtce,
  activateXtce,
  deleteXtce,
};
export default MissionService;
